import map from "lodash/map";
import { Template } from "../../../types/customization/template";
import { findPageDefinition } from "../../../utils/customization/finders";
import { ContentFormatV5 } from "../v5/content_format";
import { TemplateFormatV5 } from "../v5/template_format";
import { ContentFormatV6 } from "../v6/content_format";
import { TemplateContentFilterPages, TemplateFormatV6 } from "../v6/template_format";

export function upgradeContentToV6(
  contentFormat: ContentFormatV5,
  template: Template
): ContentFormatV6 {
  return {
    ...contentFormat,
    definition_version: 6,

    pages: map(contentFormat.pages, (pageContent) => {
      const pageDefinition = findPageDefinition(pageContent.page_definition_key, template);
      const colorDefinition = template.colorDefinitions.find((definition) => {
        return (
          definition.backgroundValue === pageContent.background_color &&
          pageDefinition.backgroundColorKeys.includes(definition.key)
        );
      });

      return {
        ...pageContent,
        background_color_key: colorDefinition?.key || pageDefinition.backgroundColorKeys[0],
      };
    }),
  };
}

export function upgradeTemplateToV6(templateFormat: TemplateFormatV5): TemplateFormatV6 {
  let defaultFilterType: string = templateFormat.template_type;
  let defaultPages: TemplateContentFilterPages[] = [];

  if (templateFormat.template_type === "book") {
    defaultFilterType = templateFormat.page_mode === "single" ? "single-page" : "layflat-page";
    defaultPages = [
      { filter_type: "front-cover" },
      { filter_type: "spine" },
      { filter_type: "back-cover" },
    ];
    if (templateFormat.page_mode === "single") {
      defaultPages.push({ filter_type: "single-front-matter" });
      defaultPages.push({ filter_type: "single-back-matter" });
    } else {
      defaultPages.push({ filter_type: "layflat-front-matter" });
      defaultPages.push({ filter_type: "layflat-back-matter" });
    }
  }

  return {
    ...templateFormat,
    definition_version: 6,

    content_page_configuration: {
      force_pack_color: false,
      forced_layouts: defaultPages,
      add_next: {
        filter_type: defaultFilterType,
      },
    },

    page_definitions: templateFormat.page_definitions.map((definition) => {
      return {
        ...definition,
        filter_type: definition.type,
      };
    }),
  };
}
